<div class="p-5 content-center">
  <app-loading-indicator />
</div>
